import {map} from 'rxjs/operators';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Company, PagedListOfCompanyMailingReport} from '../../../../services/api.client';
import {ITableHeader} from '../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';

import {PaymentProcessingFormComponent} from '../PaymentProcessingFormComponent';
import {formatPhone, formatCurrency} from '../../../../utilities/Util';
import {PledgeStatusType} from '../../../../services/api.client';

@Component({
    selector: 'companyMailing',
    templateUrl: './CompanyMailingLabelComponent.html',
    styleUrls: ['./CompanyMailingLabelComponent.scss'],
    standalone: false
})

export class CompanyMailingLabelComponent implements AfterViewInit {
  tableHeaders: ITableHeader[] = [
    {text: 'Company', sortKey: 'company'},
    {text: 'Address1', sortKey: 'address1'},
    {text: 'Address2', sortKey: 'address2'},
    {text: 'City', sortKey: 'city'},
    {text: 'State', sortKey: 'state'},
    {text: 'Zipcode', sortKey: 'zipcode'},
    {text: 'ContactName1', sortKey: 'contactName1'},
    {text: 'ContactPhone1', sortKey: 'contactPhone1'},
    {text: 'ContactName2', sortKey: 'contactName2'},
    {text: 'ContactPhone2', sortKey: 'contactPhone2'},
    {text: 'ContactName3', sortKey: 'contactName3'},
    {text: 'ContactPhone3', sortKey: 'contactPhone3'},
    {text: 'AmountPledged', sortKey: 'amountPledged'},
  ];

  @ViewChild('form')
  form: PaymentProcessingFormComponent;

  private readonly _report$ = new BehaviorSubject<PagedListOfCompanyMailingReport>(null);
  report$: Observable<PagedListOfCompanyMailingReport> = this._report$.asObservable();

  report: PagedListOfCompanyMailingReport;
  rows: any;

  submitReport(): void {
    this.form.submitCompanyMailingLabel()?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
  }

  onTableUpdate(pagedList: PagedListOfCompanyMailingReport): void {
    this.form.submitCompanyMailingLabel(pagedList.offset, pagedList.limit)
        ?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
        this.rows = this.report$
            .pipe(
                map((reports) => reports?.items?.map((report) => [
                    report.company,
                    report.address1,
                    report.address2,
                    report.city,
                    report.state,
                    report.zipcode,
                    report.contactName1,
                    formatPhone(report.contactPhone1),
                    report.contactName2,
                    formatPhone(report.contactPhone2),
                    report.contactName3,
                    formatPhone(report.contactPhone3),
                    formatCurrency(report.amountPledged),
                ])));
        this.form.form.get('displayPledgeStatus').reset(PledgeStatusType.Confirmed);
    }, 0);
  }
}

